import type { MiniMapCtaVariant } from '@repo/types/analytic-events/maps-analytic-events';

export const MINI_MAP_CTA_EXPERIMENT: 'mini_map_education_cta' = 'mini_map_education_cta';
export const MINI_MAP_CTA_VARIANT_COOKIE = 'wand_mini_map_cta_variant';
export const MINI_MAP_CTA_SEEN_STORAGE_KEY = 'wand_mini_map_cta_seen';

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function getOrAssignMiniMapCtaVariant(
    cookieString: string,
    random: () => number = Math.random,
): MiniMapCtaVariant {
    const match = cookieString.match(new RegExp(`(?:^|; )${MINI_MAP_CTA_VARIANT_COOKIE}=([^;]*)`));
    const storedVariant = match?.[1];

    if (storedVariant === 'a' || storedVariant === 'b') {
        return storedVariant;
    }

    return random() < 0.5 ? 'a' : 'b';
}

export function persistMiniMapCtaVariant(variant: MiniMapCtaVariant): void {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    // biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API is not supported in every target browser.
    document.cookie = `${MINI_MAP_CTA_VARIANT_COOKIE}=${variant}; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

export function getMiniMapCtaSeenKey(userId: string, titleId: string): string {
    return `${userId}:${titleId}`;
}

export function hasSeenMiniMapCta(storageValue: string | null, key: string): boolean {
    if (!storageValue) return false;

    try {
        const seenKeys: unknown = JSON.parse(storageValue);
        return Array.isArray(seenKeys) && seenKeys.includes(key);
    } catch {
        return false;
    }
}

export function addMiniMapCtaSeenKey(storageValue: string | null, key: string): string {
    let seenKeys: string[] = [];

    if (storageValue) {
        try {
            const parsed: unknown = JSON.parse(storageValue);
            if (Array.isArray(parsed)) {
                seenKeys = parsed.filter((value): value is string => typeof value === 'string');
            }
        } catch {
            seenKeys = [];
        }
    }

    return JSON.stringify([...new Set([...seenKeys, key])]);
}
